import type { EditorConfig, LexicalEditor, NodeKey, SerializedElementNode, Spread } from 'lexical';
import { DecoratorNode } from 'lexical';
import React from 'react';
import { CACaptionComponent, CACaptionData } from './CACaptionComponent';

export type SerializedCACaptionNode = Spread<
  {
    type: 'ca-caption';
    version: 1;
    data: CACaptionData & { additionalParties?: string[]; alignFields?: boolean; titleBold?: boolean; titleItalic?: boolean };
  },
  SerializedElementNode
>;

export class CACaptionNode extends DecoratorNode<React.ReactElement> {
  __data: CACaptionData & { additionalParties?: string[]; alignFields?: boolean; titleBold?: boolean; titleItalic?: boolean };

  static getType(): string {
    return 'ca-caption';
  }

  static clone(node: CACaptionNode): CACaptionNode {
    return new CACaptionNode(node.__data, node.__key);
  }

  constructor(data: CACaptionData & { additionalParties?: string[]; alignFields?: boolean; titleBold?: boolean; titleItalic?: boolean }, key?: NodeKey) {
    super(key);
    this.__data = data;
  }

  createDOM(_config: EditorConfig): HTMLElement {
    const el = document.createElement('div');
    el.className = 'ca-caption-node';
    return el;
  }

  updateDOM(): boolean {
    return false;
  }

  exportJSON(): SerializedCACaptionNode {
    return {
      type: 'ca-caption',
      version: 1,
      data: this.__data,
    } as unknown as SerializedCACaptionNode;
  }

  static importJSON(serializedNode: SerializedCACaptionNode): CACaptionNode {
    return new CACaptionNode(serializedNode.data);
  }

  decorate(editor: LexicalEditor, _config: EditorConfig): React.ReactElement {
    return React.createElement(CACaptionComponent, {
      ...this.__data,
      readOnly: false,
      onChange: (patch) => {
        editor.update(() => {
          const writable = this.getWritable();
          (writable as any).__data = { ...(writable as any).__data, ...patch };
        });
      },
      onFocusTitle: () => {
        (window as any).__captionFocus = { nodeKey: this.getKey(), field: 'title' };
      },
      onBlurTitle: () => {
        (window as any).__captionFocus = null;
      },
    });
  }
}

export function $createCACaptionNode(
  data: CACaptionData & { additionalParties?: string[]; alignFields?: boolean; titleBold?: boolean; titleItalic?: boolean }
): CACaptionNode {
  return new CACaptionNode(data);
}

export function $isCACaptionNode(node: unknown): node is CACaptionNode {
  return node instanceof CACaptionNode;
}


